import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from '@material-tailwind/react';
import PieChart from './icons/PieChart';
import Cog from './icons/Cog';
import Currency from './icons/Currency';
import Briefcase from './icons/Briefcase';

var TabSetup = function TabSetup() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var dasboardFearures = [{
    id: 1,
    label: t('landing.dasboardFearures.viewCalendar'),
    value: 'viewCalendar',
    icon: /*#__PURE__*/_jsx(PieChart, {}),
    image: 'https://kreezus.com/wp-content/uploads/2022/05/Dashboard.png'
  }, {
    id: 2,
    label: t('landing.dasboardFearures.setupCalendar'),
    value: 'setupCalendar',
    icon: /*#__PURE__*/_jsx(Cog, {}),
    image: 'https://kreezus.com/wp-content/uploads/2022/05/Dashboard2.png'
  }, {
    id: 3,
    label: t('landing.dasboardFearures.yourAppointments'),
    value: 'yourAppointments',
    icon: /*#__PURE__*/_jsx(Currency, {}),
    image: 'https://kreezus.com/wp-content/uploads/2022/05/Dashboard3.png'
  }, {
    id: 4,
    label: t('landing.dasboardFearures.integrateExternalDependencia'),
    value: 'integrateExternalDependencia',
    icon: /*#__PURE__*/_jsx(Briefcase, {}),
    image: 'https://kreezus.com/wp-content/uploads/2022/05/Dashboard4.png'
  }];
  return /*#__PURE__*/_jsx("section", {
    className: "px-4 py-8 border-b DetailSection",
    children: /*#__PURE__*/_jsxs("div", {
      className: "container m-8 mx-auto max-w-7xl",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "w-full my-2 text-4xl font-black leading-tight text-center text-gray-800 lg:text-5xl",
        children: t('landing.dasboardFearures.title')
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full mb-2",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-64 h-1 py-0 mx-auto my-0 rounded-t opacity-25 gradient"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "mt-2 text-center",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "text-2xl font-black text-gray-600",
          children: t('landing.dasboardFearures.subTitle')
        }), /*#__PURE__*/_jsx("p", {
          className: "max-w-4xl mx-auto mt-3 mb-8 text-base text-gray-500 sm:mt-5 sm:text-xl",
          children: t('landing.dasboardFearures.description')
        })]
      }), /*#__PURE__*/_jsxs(Tabs, {
        value: "viewCalendar",
        children: [/*#__PURE__*/_jsx(TabsHeader, {
          className: "grid sm:grid-cols-4 sm:mt-26",
          children: dasboardFearures.map(function (_ref) {
            var label = _ref.label,
                id = _ref.id,
                icon = _ref.icon,
                value = _ref.value;
            return /*#__PURE__*/_jsx(Tab, {
              value: value,
              className: "flex items-center justify-center mb-6",
              children: /*#__PURE__*/_jsxs("div", {
                className: "flex items-center",
                children: [/*#__PURE__*/_jsx("span", {
                  className: "mr-2",
                  children: icon
                }), " ", t(label)]
              })
            }, id);
          })
        }), /*#__PURE__*/_jsx(TabsBody, {
          children: dasboardFearures.map(function (_ref2) {
            var id = _ref2.id,
                image = _ref2.image,
                label = _ref2.label,
                value = _ref2.value;
            return /*#__PURE__*/_jsx(TabPanel, {
              value: value,
              children: /*#__PURE__*/_jsx(Image, {
                src: image,
                alt: label,
                layout: "responsive",
                width: 1918,
                height: 922
              })
            }, id);
          })
        })]
      })]
    })
  });
};

export default TabSetup;